/*
 * HelpScreen1
 * ==========
 */
import HelpBase from '../ui/HelpBase'

export default class HelpScreen1 extends HelpBase {

    constructor(game, screens) {
        super(game);

        this.screens = screens;

        this.page = 1;

        this.params = {
            'helpWinnerText1P': [70, 170],
            'helpWinnerText2P': [-61, -135],
            'helpWinnerGridP': [-26, 24],
            'helpWinnerUiP': [2, 306],
            'helpWinnerText1L': [-166, 65],
            'helpWinnerText2L': [49, -135],
            'helpWinnerGridL': [57, 27],
            'helpWinnerUiL': [-240, -150],

            'prevL': [-54, 194],
            'nextL': [158, 194],
            'exitL': [54, 194],

            'prevP': [-103, -274],
            'nextP': [107, -274],
            'exitP': [2, -274]
        };

        this.helpWinnerText1P = this.addSprite('helpWinnerText1P', 'helpScreens', 'helpWinnerText1.png', 'p');
        this.helpWinnerText2P = this.addSprite('helpWinnerText2P', 'helpScreens', 'helpWinnerText2.png', 'p');
        this.helpWinnerGridP = this.addSprite('helpWinnerGridP', 'helpScreens', 'helpWinnerGrid.png', 'p');
        this.helpWinnerUiP = this.addSprite('helpWinnerUiP', 'helpScreens', 'helpWinnerUi.png', 'p');

        this.helpWinnerText1L = this.addSprite('helpWinnerText1L', 'helpScreens', 'helpWinnerText1.png', 'l');
        this.helpWinnerText2L = this.addSprite('helpWinnerText2L', 'helpScreens', 'helpWinnerText2.png', 'l');
        this.helpWinnerGridL = this.addSprite('helpWinnerGridL', 'helpScreens', 'helpWinnerGrid.png', 'l');
        this.helpWinnerUiL = this.addSprite('helpWinnerUiL', 'helpScreens', 'helpWinnerUiLandscape.png', 'l');

        this.helpWinnerText1L.scale.set(0.85);

        this.initHelpButtons(true, false);

        this.setInputForAllButtons(false);
    }

}
